"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _button = require("@jsluna/button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RatingBuilder = function RatingBuilder(_ref) {
  var id = _ref.id,
      ratingOptions = _ref.ratingOptions,
      setBranchFrom = _ref.setBranchFrom,
      activeConditions = _ref.activeConditions;
  var options = Array.from(Array(ratingOptions).keys()).map(function (x, i) {
    return {
      value: i + 1,
      label: i + 1
    };
  });

  var getActiveCondition = function getActiveCondition(value) {
    if (!activeConditions) return [];
    if (activeConditions.length === 0) return [];
    var matches = activeConditions.filter(function (x) {
      return x.value === value;
    });
    return matches;
  };

  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    GridItem: true,
    size: "1/1",
    className: "ln-u-text-align-left ln-u-color-grey-50"
  }, "Strongly disagree"), options.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1",
      className: "ln-u-margin-bottom",
      key: id + "-" + x.value + "-ratingBuilder"
    }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/2"
    }, /*#__PURE__*/_react.default.createElement(_form.RadioButton, {
      label: x.label,
      disabled: true
    })), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/2"
    }, getActiveCondition(x.value).length > 0 ? /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
      color: "dark",
      onClick: function onClick() {
        return setBranchFrom(id, x.label);
      },
      fullWidth: true
    }, "Go to Q", getActiveCondition(x.value)[0].question.position) : /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
      onClick: function onClick() {
        return setBranchFrom(id, x.label);
      },
      className: "ln-u-bg-color-white",
      fullWidth: true
    }, "Go to another question")));
  }), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    GridItem: true,
    size: "1/1",
    className: "ln-u-text-align-left ln-u-color-grey-50"
  }, "Strongly agree"));
};

RatingBuilder.propTypes = {
  /** The unique identifier of the question */
  id: _propTypes.default.string.isRequired,

  /** Indicates how many ratings are displayed */
  ratingOptions: _propTypes.default.number.isRequired,

  /** Function to set the question/value combination for branching questions */
  setBranchFrom: _propTypes.default.func.isRequired,

  /** A list of conditions that are linked to the question */
  activeConditions: _propTypes.default.array
};
var _default = RatingBuilder;
exports.default = _default;